import {
    Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Admin_Parivartan_Create_New_State } from "../../../../constants";
import axios from "axios";
import toast from "react-hot-toast";

const AddNewStateModal = ({ open, onClose, onRefresh }) => {
  const [stateName, setStateName] = useState("");

  const handleSubmit = async () => {
    const payload = {
        stateName: stateName,
      };
  
      try {
        const res = await axios.post(Admin_Parivartan_Create_New_State, payload);
        if (res.data.success) {
          toast.success("State Created Successfully.");
          onClose();
          onRefresh();
          handleReset();
        } else{
          toast.error(res.data.message || 'Failed to create state');
        }
      } catch (err) {
        const message =
          err?.response?.data?.message || err?.message || 'Something went wrong';
        toast.error(message);
      }
  };

  const handleReset = () => {
    setStateName("");
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Add New State
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              labelId="state-label"
              label="State Name"
              value={stateName}
              onChange={(e) => setStateName(e.target.value)}
              size="small"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddNewStateModal;
